// @ts-nocheck
import React, { lazy } from 'react';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const CreateShippingAddressDialogContent = lazy(() =>
  import('./CreateShippingAddressDialogContent'),
);

function CreateShippingAddressDialog({ dialogName, payload = {}, isOpen }) {
  const mode = payload.mode ?? 'create';
  return (
    <Dialog
      name={dialogName}
      className="dialog--create-shipping-address"
      isOpen={isOpen}
      autoFocus
      canEscapeKeyClose
      style={{ width: '560px' }}
      title={mode === 'edit' ? 'Edit Shipping Address' : 'Add Shipping Address'}
    >
      <DialogSuspense>
        <CreateShippingAddressDialogContent
          dialogName={dialogName}
          scopeType={payload.scopeType ?? null}
          scopeId={payload.scopeId ?? null}
          mode={mode}
          address={payload.address ?? null}
          onSaved={payload.onSaved ?? null}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(CreateShippingAddressDialog);
